import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { captureException } from '@playbookux/playbook-web-core';
import { func, string } from 'prop-types';
import {
  ContainerEdit,
  EditText,
  Input,
  Label,
  Modal,
  ModalButton,
  ModalCancelButton,
  ModalFooter,
  ModalHeader,
  TextError,
} from './styles';
import { EDIT_NAME_VIDEO_PARTICIPANT } from './graphql';
import { EDIT_TEXT, TITLE_MODAL } from './constants';
import { schema } from './schema';

const EditModalUpload = (props) => {
  const { testerId, profileFirstName, refetch } = props;
  const profileFirstNameSplitted = profileFirstName.split('.')[0];

  const [openModal, setOpenModal] = useState(false);
  const [name, setName] = useState(profileFirstNameSplitted);
  const [nameError, setNameError] = useState('');

  const [editNameVideo, { loading }] = useMutation(EDIT_NAME_VIDEO_PARTICIPANT, {
    onCompleted: () => {
      refetch();
    },
  });

  const handleOpenAndCloseModal = () => {
    setOpenModal((prev) => !prev);
  };

  /**
   * This function is used to handle the input change
   * @param {Object} event
   * @param {Object} value
   */
  const handleInputChange = (event, { value }) => {
    setName(value);
    schema.validate(value)
      .then(() => {
        setNameError('');
      })
      .catch((err) => {
        setNameError(err.message);
      });
  };

  /**
   * This function is used to handle the save
   * @returns {Promise<void>}
   */
  const handleSave = async () => {
    try {
      await editNameVideo({
        variables: {
          testerId,
          nameVideo: name,
        },
      });
    } catch (e) {
      captureException('EDIT_NAME_VIDEO_FAILED', e);
    } finally {
      setOpenModal(false);
    }
  };

  return (
    <>
      <ContainerEdit>
        <EditText onClick={handleOpenAndCloseModal}>
          {EDIT_TEXT}
        </EditText>
      </ContainerEdit>

      {openModal && (
        <Modal open={openModal} onClose={handleOpenAndCloseModal} size="tiny">
          <ModalHeader>
            {TITLE_MODAL}
          </ModalHeader>

          <>
            <Label>Name</Label>
            <Input
              size="small"
              id="editNameParticipant"
              onChange={handleInputChange}
              loading={loading}
              value={name}
            />
            {nameError && <TextError>{nameError}</TextError>}
          </>

          <ModalFooter>
            <p style={{ visibility: 'hidden' }} />
            <ModalCancelButton disabled={loading} onClick={handleOpenAndCloseModal}>
              Cancel
            </ModalCancelButton>

            <ModalButton onClick={handleSave} loading={loading} disabled={loading || nameError}>
              Save
            </ModalButton>

          </ModalFooter>
        </Modal>
      )}

    </>
  );
};

EditModalUpload.propTypes = {
  testerId: string.isRequired,
  profileFirstName: string.isRequired,
  refetch: func.isRequired,
};

EditModalUpload.defaultProps = {};

export default EditModalUpload;
